import { useEffect } from "react";

/**
 * Update document.title and meta description for SEO on route-level pages.
 * Restores the previous values on unmount so SPA navigation doesn't leak
 * stale meta into other routes.
 */
export const useDocumentMeta = ({ title, description, canonical, image }) => {
  useEffect(() => {
    const prevTitle = document.title;
    const descEl = document.querySelector('meta[name="description"]');
    const prevDesc = descEl ? descEl.getAttribute("content") : null;
    const canonEl = document.querySelector('link[rel="canonical"]');
    const prevCanon = canonEl ? canonEl.getAttribute("href") : null;
    const ogTitle = document.querySelector('meta[property="og:title"]');
    const prevOgTitle = ogTitle ? ogTitle.getAttribute("content") : null;
    const ogDesc = document.querySelector('meta[property="og:description"]');
    const prevOgDesc = ogDesc ? ogDesc.getAttribute("content") : null;
    const ogUrl = document.querySelector('meta[property="og:url"]');
    const prevOgUrl = ogUrl ? ogUrl.getAttribute("content") : null;
    const ogImage = document.querySelector('meta[property="og:image"]');
    const prevOgImage = ogImage ? ogImage.getAttribute("content") : null;
    const twImage = document.querySelector('meta[name="twitter:image"]');
    const prevTwImage = twImage ? twImage.getAttribute("content") : null;

    if (title) document.title = title;
    if (description && descEl) descEl.setAttribute("content", description);
    if (canonical && canonEl) canonEl.setAttribute("href", canonical);
    if (title && ogTitle) ogTitle.setAttribute("content", title);
    if (description && ogDesc) ogDesc.setAttribute("content", description);
    if (canonical && ogUrl) ogUrl.setAttribute("content", canonical);
    if (image && ogImage) ogImage.setAttribute("content", image);
    if (image && twImage) twImage.setAttribute("content", image);

    return () => {
      document.title = prevTitle;
      if (descEl && prevDesc !== null) descEl.setAttribute("content", prevDesc);
      if (canonEl && prevCanon !== null) canonEl.setAttribute("href", prevCanon);
      if (ogTitle && prevOgTitle !== null) ogTitle.setAttribute("content", prevOgTitle);
      if (ogDesc && prevOgDesc !== null) ogDesc.setAttribute("content", prevOgDesc);
      if (ogUrl && prevOgUrl !== null) ogUrl.setAttribute("content", prevOgUrl);
      if (ogImage && prevOgImage !== null) ogImage.setAttribute("content", prevOgImage);
      if (twImage && prevTwImage !== null) twImage.setAttribute("content", prevTwImage);
    };
  }, [title, description, canonical, image]);
};
